
    import { Component } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import { MonthPicker } from 'vue-month-picker'
    //import { __await } from 'tslib';

    @Component({
        components: { VWidget, MonthPicker },
        watch: {
            dealer: function (val) {
                (this as any).loadData();
            },
            manufacturer: function (val) {
                (this as any).loadData();
            }
        }
    })

    export default class ChartOperation extends ListBase {
        //period: any = parseInt(new Date().toISOString().substr(0, 4));
        //month_from: any = 1;
        //month: any = parseInt(new Date().toISOString().substr(5, 2));
        selectedType: number = this.types[0].id;
        menuFrom: boolean = false;
        menuTo: boolean = false;
        rangeFrom: any = {
            from: 0,
            to: parseInt(new Date().toISOString().substr(5, 2)) - 1,
            fromText: 'Enero',
            toText: this.gCommonList('months')[parseInt(new Date().toISOString().substr(5, 2)) - 1].name,
            year: parseInt(new Date().toISOString().substr(0, 4)) - 1
        };
        rangeTo: any = {
            from: 0,
            to: parseInt(new Date().toISOString().substr(5, 2)) - 1,
            fromText: 'Enero',
            toText: this.gCommonList('months')[parseInt(new Date().toISOString().substr(5, 2)) - 1].name,
            year: parseInt(new Date().toISOString().substr(0, 4))
        };

        get columns() {
            let months = this.gCommonList('months');
            let titleFrom = this.rangeFrom.fromText.toUpperCase().substr(0, 3) + '-' + this.rangeFrom.toText.toUpperCase().substr(0, 3) + '-' + this.rangeFrom.year;
            let titleTo = this.rangeTo.fromText.toUpperCase().substr(0, 3) + '-' + this.rangeTo.toText.toUpperCase().substr(0, 3) + '-' + this.rangeTo.year;
            return [
                { value: 'name', text: '', type: 'text', sortable: false, align: 'start', class: 'simple-col', cellClass: 'titles' },
                { value: 'total_invoiced_last', text: 'Total Factu ' + titleFrom, type: 'price', sortable: false, align: 'end', width: '100px', class: 'simple-col inv-col' },
                { value: 'steps', text: 'Pasos', type: 'per', sortable: false, align: 'center', width: null, class: 'simple-col' },
                { value: 'ticket_mo', text: 'Ticket MO', type: 'per', sortable: false, align: 'center', width: null, class: 'simple-col' },
                { value: 'ticket_rep', text: 'Ticket REP', type: 'per', sortable: false, align: 'center', width: null, class: 'simple-col' },
                { value: 'ticket_total', text: 'Total Ticket', type: 'per', sortable: false, align: 'center', width: null, class: 'simple-col' },
                { value: 'total_invoiced', text: 'Total Factu ' + titleTo, type: 'price', sortable: false, align: 'end', width: '100px', class: 'simple-col inv-col', cellClass: 'invoices' },
                { value: 'var', text: 'Var', type: 'percent', sortable: false, align: 'center', width: null, class: 'simple-col inv-col' },
                { value: 'peso', text: 'Peso', type: 'percent', sortable: false, align: 'center', width: null, class: '' },
            ];
        }

        get periods() {
            return this.gCommonList('years');
        }

        get months() {
            let list = this.gCommonList('months');
            list.forEach(m => {
                m['field'] = 'month_' + m.id;
            });
            return list;
        }

        get types() {
            return [{ id: null, name: 'Todos' }, ...Util.abp.list.getList('T_VEHICLE')];
        }

        get dealer() {
            return this.$store.state.app.dealer;
        }

        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }

        get loading() {
            return this.$store.state.figure.loading;
        }

        get list() {
            return this.$store.state.figure.reportList;
        }
        
        async changeFrom(data) {
            this.rangeFrom.from = data.rangeFrom;
            this.rangeFrom.to = data.rangeTo;
            this.rangeFrom.fromText = data.rangeFromMonth;
            this.rangeFrom.toText = data.rangeToMonth;
            this.rangeFrom.year = data.year;
            this.menuFrom = false;
            await this.loadData();
        }

        async changeTo(data) {
            this.rangeTo.from = data.rangeFrom ;
            this.rangeTo.to = data.rangeTo;
            this.rangeTo.fromText = data.rangeFromMonth;
            this.rangeTo.toText = data.rangeToMonth;
            this.rangeTo.year = data.year;
            this.menuTo = false;
            await this.loadData();
        }
                       
        async loadData() {
            await this.$store.dispatch({
                type: 'figure/getResumenComparativo',
                data: {
                    fromYear: this.rangeFrom.year,
                    fromMonth1: this.rangeFrom.from + 1,
                    fromMonth2: this.rangeFrom.to + 1,
                    toYear: this.rangeTo.year,
                    toMonth1: this.rangeTo.from + 1,
                    toMonth2: this.rangeTo.to + 1,
                    //type: this.selectedType,
                    dealer: this.dealer,
                    manufacturer: this.manufacturer,
                }
            });          
        }

        mounted() { 
            this.loadData();
        }
    }
